export default __webpack_public_path__ + "4d88ef36a5df4ecefdbf54c494446fc0.png";